module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/secondary_address.js
// module id = 1446
// module chunks = 0